/* eslint-disable react/forbid-elements -- social and app links will always be external */
import '../styles/social-app-links.scss'
import { Icon } from '@vista-digital/occ-ui'
import type { FC } from 'react'
import { cmsDataService } from '@/common/services/cms.data.service'

export const SocialAndAppLinks: FC = () => {
    const links = cmsDataService.get().footer.socialAndAppLinks

    return (
        <div className="footer-socials">
            {links.title && <h5>{links.title}</h5>}
            <span className="footer-socials__platforms">
                <SocialLink link={links.tiktokLink} icon="tiktok" />
                <SocialLink link={links.instagramLink} icon="instagram" />
                <SocialLink link={links.twitterLink} icon="twitter" />
                <SocialLink link={links.facebookLink} icon="facebook" />
            </span>
            <SocialLink className="footer-socials__app-link" link={links.appleStoreLink} icon="app-store" />
            <SocialLink className="footer-socials__app-link" link={links.googlePlayLink} icon="google-play" />
        </div>
    )
}

const SocialLink: FC<{ link: string | undefined; icon: string; viewBox?: string; className?: string }> = ({
    link,
    icon,
    viewBox,
    className,
}) => {
    return (
        <>
            {link && (
                <a href={link} target={'_blank'} className={className}>
                    <Icon name={icon} viewBox={viewBox} />
                </a>
            )}
        </>
    )
}
